import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './LanguageSwitch.css';

const LanguageSwitch = () => {
  const { lang, toggleLanguage } = useLanguage();

  return (
    <button
      className="language-switch"
      onClick={toggleLanguage}
      aria-label={lang === 'pt' ? 'Switch to English' : 'Mudar para Português'}
      title={lang === 'pt' ? 'Switch to English' : 'Mudar para Português'}
    >
      <span className={`lang-option ${lang === 'pt' ? 'active' : ''}`}>PT</span>
      <span className="lang-divider">|</span>
      <span className={`lang-option ${lang === 'en' ? 'active' : ''}`}>EN</span>
    </button>
  );
};

export default LanguageSwitch;
